import { Domain } from "@/types/domain";

export const utthungaDomains: Domain[] = [
  {
    symbol: "ProdEng",
    name: "Product Engineering",
    categories: "Core Services",
  },
  {
    symbol: "IndSol",
    name: "Industrial Solutions",
    categories: "Core Services",
  },
  {
    symbol: "FwHw",
    name: "Firmware & Hardware",
    categories: "Engineering",
  },
  {
    symbol: "IIoT",
    name: "Industrial IoT",
    categories: "Digital",
  },
  {
    symbol: "ItOt",
    name: "IT-OT Integration",
    categories: "Integration",
  },
  {
    symbol: "FieldDev",
    name: "Field Device Integration",
    categories: "Integration",
  },
  {
    symbol: "IndComm",
    name: "Industrial Communications",
    categories: "Protocols",
  },
  {
    symbol: "SecEng",
    name: "Security Engineering",
    categories: "Security",
  },
  {
    symbol: "ProcInd",
    name: "Process Industry",
    categories: "Verticals",
  },
  {
    symbol: "FactAuto",
    name: "Factory Automation",
    categories: "Verticals",
  },
  {
    symbol: "PowerSys",
    name: "Power Systems",
    categories: "Verticals",
  },
  {
    symbol: "BuildAuto",
    name: "Building Automation",
    categories: "Verticals",
  },
  {
    symbol: "Mobility",
    name: "Mobility Solutions",
    categories: "Verticals",
  },
  {
    symbol: "DigTwin",
    name: "Digital Twins",
    categories: "Digital",
  },
  {
    symbol: "Analytics",
    name: "Industrial Analytics",
    categories: "Digital",
  },
];
